import { EnumBase } from 'hay-core-react';
class TipoPagamentoEnum extends EnumBase {
    constructor() {
        super(
            [
                'main.modalidade.tipopagamento.prepago',
                'main.modalidade.tipopagamento.pospago',
            ],
            'main.modalidade.tipopagamento.prepago'
        );
    }
}

const instance = new TipoPagamentoEnum();
export default instance;
